import { render, staticRenderFns } from "./ShortAnswer.vue?vue&type=template&id=12b0d7ea&scoped=true&"
import script from "./ShortAnswer.vue?vue&type=script&lang=ts&"
export * from "./ShortAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./ShortAnswer.vue?vue&type=style&index=0&id=12b0d7ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b0d7ea",
  null
  
)

export default component.exports